import type { App } from 'vue'
import { CACHE_KEY, useCache } from '@/hooks/web/useCache'

// 修复：移除模块顶层的 useI18n 调用 - 2025-11-23
// const { t } = useI18n() // 国际化

export function hasRole(app: App<Element>) {
  app.directive('hasRole', (el, binding) => {
    const { wsCache } = useCache()
    const { value } = binding
    const super_admin = 'super_admin'
    const userInfo = wsCache.get(CACHE_KEY.USER)
    const roles = userInfo?.roles || []

    if (value && value instanceof Array && value.length > 0) {
      const roleFlag = value

      const hasRole = roles.some((role: string) => {
        return super_admin === role || roleFlag.includes(role)
      })

      if (!hasRole) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      // 修复：在函数内部获取 i18n - 2025-11-23
      const { t } = useI18n()
      throw new Error(t('permission.hasRole'))
    }
  })
}
